<template>
  <div class="result_container">
    <div class="hd">
      <span class="header_title">转赠好友</span>
    </div>
    <div class="box">
      <div class="main">
        <div class="outer_3">
            <div class="outer_attr" @click="autofocus('search_name')">
              <div class="group">
                <div class="attr_name">姓名</div>
                <input class="input_text" v-model.trim="nameQuery" id="search_name" type="text" placeholder="请输入被转赠人姓名">
              </div>
              <div class="container"><div class="empty"></div></div>
            </div>
            <div class="outer_attr" @click="autofocus('search_mobile')">
              <div class="group">
                <div class="attr_name">手机号码</div>
                <input class="input_text" v-model.trim="mobileQuery" id="search_mobile" type="text" placeholder="请输入被转赠人手机号码">
              </div>
              <div class="container"><div class="empty"></div></div>
            </div>
        </div>
      </div>
      <div class="button-group">
        <div class="return-button" style="width: 47%;background-color: transparent;" @click="changeMind()"><span class="button-name" style="color:#013c8e;" >返回上一步</span></div>
        <div class="return-button" style="width: 47%;" @click="searchContact()"><span class="button-name">转赠优惠券</span></div>
      </div>
    </div>
  </div>
</template>
<script>
  import $ from 'jquery'
  import { mapGetters, mapState } from 'vuex'
  import Emkt from '../../../emkt'
  export default {
    data () {
      return {
        constants: {},
        nameQuery: '',
        mobileQuery: '',
        waitRegister: false
      }
    },
    computed: {
      ...mapState([
        'sessionInfo'
      ]),
      ...mapGetters([
        'hasLogin', 'customerName'
      ]),
      mobile () {
        return this.sessionInfo && this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.mobile
      },
      enterpriseName () {
        return this.sessionInfo && this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.enterpriseName
      },
      customerNo () {
        return this.sessionInfo && this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.customerNo
      }
    },
    methods: {
      autofocus (id) {
        $('#' + id).focus()
      },
      resetWindow () {
        setTimeout(() => {
          window.scrollTo(0, 0)
          console.log('reset invoked')
        }, 300)
      },
      validatemobile (mobile) {
        if (mobile.length === 0) {
          $.toast('手机号码不能为空')
          return false
        }
        let myreg = /^1[3-9]{1}[0-9]{9}$/
        if (mobile.length !== 11 || !myreg.test(mobile)) {
          $.toast('请输入有效的手机号码')
          return false
        }
        return true
      },
      searchContact () {
        this.resetWindow()
        if (!this.nameQuery || !this.validatemobile(this.mobileQuery)) {
          $.toast('请输入姓名和正确的手机号')
          return
        }
        // 根据联系人手机号、姓名搜索联系人个人信息
        if (this.hasLogin) {
          const queryParam = {}
          queryParam.customerName = this.nameQuery
          queryParam.mobile = this.mobileQuery
          $.showPreloader('查询中')
          this.gcapi('@gcwwwifc/queryCustomerInfoByMobileAndName', queryParam).then(response => {
            $.hidePreloader()
            if (response && response.body === 'null') {
              $.modal({
                title: '该用户未注册',
                text: '邀请用户注册后，发放折扣券。若该用户已经注册，请重新核对您填写的信息是否正确',
                buttons: [{
                  text: '核对信息',
                  onClick: function () {
                  }
                }, {
                  text: '邀请注册',
                  onClick: () => {
                    this.waitRegister = true
                    this.saveInfoCollectionIntoDB(this.nameQuery, this.mobileQuery)
                  }
                }]
              })
              return
            } else if (response && response.body.length > 0) {
              this.waitRegister = false
              this.saveInfoCollectionIntoDB(this.nameQuery, this.mobileQuery)
            }
          }).catch(e => {
            console.log('e', e)
          })
        }
      },
      sendRegistrationText (name, mobile) {
        let textString = `${name}老师，您好！您的好友${this.customerName}老师因为参与援鄂活动，享受吉凯基因提供的专属「定制产品6折券」，他已经将该福利赠与您使用，您可以登录吉凯淘基因商城www.taogene.com查看福利并使用`
        const queryParam = {}
        queryParam.mobile = mobile
        queryParam.message = textString
        this.gcapi('@gcwwwifc/requestRegiserInvitation', queryParam).then((res) => {
          if (res && res.body.code === 0) return $.toast('发送成功')
          return $.toast('发送失败')
        })
      },
      saveInfoCollectionIntoDB (queryName, queryMobile) {
        const formCollectionActivity = {
          'customerNo': this.customerNo,
          'customerMobile': this.mobile,
          'customerName': this.customerName,
          'customerEnterpriseName': this.enterpriseName,
          'activityName': '618领取优惠券',
          'attachmentName': Emkt.getLocalStorage('promotionGuids618Used'),
          'additionalinfos': []
        }
        formCollectionActivity['additionalinfos'].push({
          'columnName': '券是否自用',
          'columnValue': queryMobile === this.mobile ? '券自用' : '券赠送'
        })
        formCollectionActivity['additionalinfos'].push({
          'columnName': '持券者电话号码',
          'columnValue': queryMobile
        })
        formCollectionActivity['additionalinfos'].push({
          'columnName': '持券者姓名',
          'columnValue': queryName
        })
        const formCollectionActivityList = []
        formCollectionActivityList.push(formCollectionActivity)
        this.gcapi('submitFormCollectionActivity', formCollectionActivityList).then((response) => {
          // 领取优惠券后，清空订单中使用的618促销guids
          Emkt.setStoreItem('promotionGuids618Used', '')
          let result, text
          // 如果转赠，发送注册短信
          if (queryMobile !== this.mobile) {
            this.sendRegistrationText(queryName, queryMobile)
            result = this.waitRegister ? '邀请成功' : '转赠成功'
            text = this.waitRegister ? '已向该用户发送注册短信邀请，折扣券将在用户完成注册后的3-5个工作日发放完毕' : '折扣券将在3-5个工作日发放完毕'
          } else {
            result = '领取成功'
            text = '折扣券将在3-5个工作日发放完毕'
          }
          this.$router.replace({name: 'OperationResult', query: {result, text, 'showLottery': this.$route.query.showLottery}})
        })
      },
      changeMind () {
        $.modal({
          title: '您确认要放弃领券？',
          buttons: [{
            text: '放弃',
            onClick: () => {
              this.$router.replace({name: 'home'})
            }
          }, {
            text: '转赠自己',
            onClick: () => {
              this.waitRegister = false
              this.saveInfoCollectionIntoDB(this.customerName, this.mobile)
            }
          }, {
            text: '取消',
            onClick: () => {
            }
          }]
        })
      }
    }
  }
</script>
<style scoped>
  .result_container {
    overflow-y:scroll;
    overflow-x:hidden;
    /*-webkit-overflow-scrolling:touch;*/
    height:100%;
  }
  .box {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: column;
    background-color: #efeef3;
    width: 100vw;
    height: 100vh;
    top: 14.93vw;
  }
  .hd {
    display: flex;
    position: fixed;
    top:0;
    left:0;
    align-items: center;
    flex-direction: row;
    /*background-color: #5878fa;*/
    width: 100vw;
    height: 14.93vw;
    z-index: 10;
    justify-content: center;
    background-color: #013C8E;
  }

  .header_title {
    opacity: 1;
    /*margin-left: 29.33vw;*/
    max-width: 60.53vw;
    height: 5.87vw;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 5.87vw;
    white-space: nowrap;
    color: #ffffff;
    font-size: 4.27vw;
    font-weight: 400;
  }

  .main {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin: 4vw 0;
    width: 100%;
  }

  .outer_3 {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: center;
    border-radius: 2.67vw;
    background-color: #ffffff;
    width: 86.67vw;
    padding: 2vw 0;
  }

  .outer_attr {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: center;
    background-color: #ffffff;
    width: 86.67vw;
    height:12.8vw;
  }
  .input_text {
    opacity: 1;
    text-align: left;
    line-height: 4.53vw;
    white-space: nowrap;
    color: #929292;
    font-size: 3.73vw;
    font-weight: 400;
    width: 58vw;
    outline: none;
    border: none;
    padding: 0;
  }
  .attr_name {
    opacity: 1;
    width: 70px;
    height: 5.33vw;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #424242;
    font-size: 3.73vw;
    font-weight: 500;
  }
  .outer_3 .outer_attr:last-child .empty{
    width: 73.6vw;
    height: 0.53vw;
    border: 0;
  }
  .empty {
    border-top-width: 0.7px;
    border-top-style: solid;
    border-top-color: rgba(213, 213, 213, 1);
    width: 73.6vw;
    height: 0.53vw;
  }
  .group {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-top: 3.47vw;
    padding-right: 6.4vw;
    padding-left: 6.67vw;
    width: 86.67vw;
  }
  .container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 4vw;
    width: 86.4vw;
  }
  .button-group {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    /*margin-top: 6.67vw;*/
    border-radius: 2.67vw;
    width: 86.67vw;
  }

  .button-name {
    opacity: 1;
    width: 100%;
    overflow: hidden;
    text-align: center;
    text-overflow: ellipsis;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #ffffff;
    font-size: 3.73vw;
    font-weight: 400;
  }

  .return-button {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    border-radius: 5.87vw;
    background-color: #013c8e;
    width: 86.67vw;
    height: 11.73vw;
    border: #013c8e 1px solid;
  }
</style>




// WEBPACK FOOTER //
// SearchContactWithoutDetail.vue?d50f79d2